import React, { MouseEventHandler } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import SahamDialog from 'components/SahamDialog';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { EXPERT_TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';

export interface ValidationDialogProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  handleValidate: any;
  expertiseType: string;
}

export const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  return (
    <SahamDialog
      handleValidate={props.handleValidate}
      handleClose={props.handleClose as MouseEventHandler}
      title={translate(messages.courtManagerConfirmationDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerConfirmationDialogCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerConfirmationDialogConfirm,
        props,
      )}
      open={props.open}
    >
      {translate(messages.courtManagerValidationJomTitle, props, {
        type:
          props.expertiseType === EXPERT_TYPE.VICTIMS
            ? translate(messages.courtManagerValidationAlertVictim, props)
            : translate(messages.courtManagerValidationAlertVehicle, props),
      })}
    </SahamDialog>
  );
};

export default injectIntl(ValidationDialog);
